<!--
 * @Author: your name
 * @Date: 2020-10-19 10:43:11
 * @LastEditTime: 2021-03-19 14:23:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\Admin\Admin.vue
-->
<template>
  <div id='admin'>
    <el-row class="admin_header">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="admin_header_l">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <img src="@/assets/img/logo.png" alt="">
        </el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
          <h3>上海信用服务行业综合智慧数据库管理平台</h3>
          <p><span>IDM</span> &emsp;<span>SYSTEM</span></p>
        </el-col>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="admin_header_r">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="loginTime"><img src="@/assets/img/admin_loginTime.png" alt=""> 上次登录 <span v-if="userInfo">{{userInfo.loginTime}}</span>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="userInfos">
          <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
          <el-link v-if="userInfo" @click="status=2" type="primary">{{userInfo.userName}}(管理员)</el-link>
          <div class="switch-account" v-if="email=='wwj13012021@163.com'||email=='wwj1301@126.com'">
            <img src="@/assets/img/rolechangeBtn.png" class="switch-account-open" alt="切换账号" @click="centerDialogVisible = true">
            <!-- 选择账号 -->
            <div class="switch-account-dialog" v-show="centerDialogVisible">
              <div class="header-title">
                <span>切换账号</span>
                <i class="el-icon-close switch-account-close" @click="centerDialogVisible = false"></i>
              </div>
              <ul class="switch-account-choose">
                <li>
                  <div>
                    <img src="@/assets/img/roleAdminIcon.png" alt="">
                    <span class="switch-account-type">魏文静</span>
                  </div>
                  <img  class="switch-account-handle " @click="roleAdminLogin" src="@/assets/img/rolechangeActive.png" alt="切换" >
                </li>
                <li>
                  <div>
                    <img src="@/assets/img/roleManageIcon.png" alt="">
                    <span class="switch-account-type">{{userInfo.userName}} (管理员)</span>
                  </div>
                  <img  class="switch-account-handle disabledIcon"  src="@/assets/img/rolechangeDisable.png" alt="切换" >
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="logout">
          <i class="el-icon-switch-button" @click="logout"></i>
        </el-col>
      </el-col>
    </el-row>
    <el-tabs v-if="status==1" class="admin_content" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane name="1" label="人员管理">
        <div class="addNewMember addNew" @click="addNewMember">新建人员</div>
        <el-table :data="adminTableData" stripe style="width: 100%">
          <el-table-column prop="personNo">
            <template slot="header" slot-scope="scope">
              人员编号
              <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                <el-input placeholder="请输入人员编号" v-model="findParams.personNo" @change="getAdminInfo">
                  <img slot="prefix" src="@/assets/img/search.png" alt="">
                </el-input>
                <i slot="reference" class="el-icon-caret-bottom arrow"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="账号名称">
          </el-table-column>
          <el-table-column prop="createTime">
            <template slot="header" slot-scope="scope">
              创建时间
              <el-popover popper-class="member_code valueTime" placement="bottom" width="100" trigger="click">
                <el-date-picker popper-class="valueTime" v-model="valueTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange">
                </el-date-picker>
                <i slot="reference" class="el-icon-caret-bottom arrow"></i>
              </el-popover>
              <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg">
            </template>
            <template slot-scope="scope">
              {{scope.row.createTime.substr(0,10)}}
            </template>
          </el-table-column>
          <el-table-column prop="email">
            <template slot="header" slot-scope="scope">
              邮箱
              <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                <el-input placeholder="请输入邮箱" v-model="findParams.email" @change="getAdminInfo">
                  <img slot="prefix" src="@/assets/img/search.png" alt="">
                </el-input>
                <i slot="reference" class="el-icon-caret-bottom arrow"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机">
          </el-table-column>
          <el-table-column prop="disabled">
            <template slot="header" slot-scope="scope">
              状态
              <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                <!-- <el-input placeholder="请输入状态" v-model="findParams.userType" @change="getAdminInfo">
                  <img slot="prefix" src="@/assets/img/search.png" alt="">
                </el-input> -->
                <el-select v-model="findParams.userType" placeholder="请选择状态" @change="getAdminInfo">
                  <el-option v-for="item in stausType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <i slot="reference" class="el-icon-caret-bottom arrow"></i>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.disabled" @change="handleSwitch(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popover popper-class="userInfo_det" placement="bottom" width="100" trigger="click">
                <p class="content" @click="editAdmin(scope.row)">编辑</p>
                <p class="content" @click="deleteAdmin(scope.row)">删除</p>
                <p class="content" @click="resetPassword(scope.row)">重置密码</p>
                <img slot="reference" class="more" src="@/assets/img/more.png" alt="">
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="one" v-if="status==1" @current-change="handleCurrentChange" :current-page.sync="findParams.pageNumber" :page-size="findParams.pageSize" layout="total, prev, pager, next" :total="totalPage">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane name="2" label=" 操作记录">
        <el-row class="selectOprate">
          <span :xs="2" :sm="2" :md="2" :lg="2" :xl="2" class="mine" :class="{active:activeIndex==0?true:false}" @click="minOpaLog">本账号操作日志</span>
          <span :xs="2" :sm="2" :md="2" :lg="2" :xl="2" class="other" :class="{active:activeIndex==1?true:false}" @click="otherOpaLog">下级操作日志</span>
        </el-row>
        <template v-if="activeIndex==0">
          <el-table :data="mineData" stripe style="width: 100%">
            <el-table-column prop="createTime">
              <template slot="header" slot-scope="scope">
                操作时间
                <el-popover popper-class="admin_mineOpa" placement="bottom" width="200" trigger="click">
                  <el-date-picker class="mineOpa_picker" v-model="mineParams.mineTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime">
                  </el-date-picker>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="mineHandleImg">
              </template>
              <template slot-scope="scope">
                {{$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")}}
              </template>
            </el-table-column>
            <el-table-column prop="ipAddress" label="IP地址">
              <template slot-scope="scope">
                {{scope.row.ipAddress==''||scope.row.ipAddress==undefined||scope.row.ipAddress==null?'/':scope.row.ipAddress}}
              </template>
            </el-table-column>
            <el-table-column prop="loginAddress" label="登录地点">
              <template slot-scope="scope">
                {{scope.row.loginAddress==''||scope.row.loginAddress==undefined||scope.row.loginAddress==null?'/':scope.row.loginAddress}}
              </template>
            </el-table-column>
            <el-table-column prop="theme">
              <template slot="header" slot-scope="scope">
                针对主体
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入针对主体" v-model.trim="mineParams.theme" @change="getOprationLog">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="operation">
              <template slot="header" slot-scope="scope">
                操作
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入操作" v-model="mineParams.operationName" @change="getOprationLog">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
              <!-- <template slot-scope="scope">
                <el-link type="primary">{{scope.row.operation}}</el-link>
              </template> -->
            </el-table-column>
          </el-table>
          <el-pagination class="two" @current-change="mineCurrentChange" :current-page.sync="mineParams.pageNumber" :page-size="mineParams.pageSize" layout="total, prev, pager, next" :total="mineTotalPage">
          </el-pagination>
        </template>
        <template v-else-if="activeIndex==1">
          <el-table :data="otherData" stripe style="width: 100%">
            <el-table-column prop="userName">
              <template slot-scope="scope">
                {{scope.row.userName?scope.row.userName:scope.row.companyName}}
              </template>
              <template slot="header" slot-scope="scope">
                账号名称
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入账号名称" v-model="mineParams.userName" @change="getOprationLog">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="createTime">
              <template slot="header" slot-scope="scope">
                操作时间
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-date-picker v-model="mineData" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime">
                  </el-date-picker>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="mineHandleImg">
              </template>
              <template slot-scope="scope">
                {{$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")}}
              </template>
            </el-table-column>
            <el-table-column prop="ipAddress" label="IP地址">
              <template slot-scope="scope">
                {{scope.row.ipAddress==''||scope.row.ipAddress==undefined||scope.row.ipAddress==null?'/':scope.row.ipAddress}}
              </template>
            </el-table-column>
            <el-table-column prop="loginAddress" label="登录地点">
              <template slot-scope="scope">
                {{scope.row.loginAddress==''||scope.row.loginAddress==undefined||scope.row.loginAddress==null?'/':scope.row.loginAddress}}
              </template>
            </el-table-column>
            <el-table-column prop="theme">
              <template slot="header" slot-scope="scope">
                针对主体
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入针对主体" v-model.trim="mineParams.theme" @change="getOprationLog">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
              <template slot-scope="scope">
                {{scope.row.theme==''||scope.row.theme==undefined||scope.row.theme==null?'/':scope.row.theme}}
              </template>
            </el-table-column>
            <el-table-column prop="operation">
              <template slot="header" slot-scope="scope">
                操作
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入操作" v-model="mineParams.operationName" @change="getOprationLog">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
              <!-- <template slot-scope="scope">
                <el-link type="primary">{{scope.row.operation}}</el-link>
              </template> -->
            </el-table-column>
          </el-table>
          <el-pagination class="three" @current-change="otherCurrentChange" :current-page.sync="mineParams.pageNumber" :page-size="mineParams.pageSize" layout="total, prev, pager, next" :total="otherTotalPage">
          </el-pagination>
        </template>
      </el-tab-pane>
    </el-tabs>
    <!-- 个人中心 -->
    <el-row v-else-if="status==2" class="admin_content">
      <el-row class="backHome">
        <span @click="status=1"><img src="@/assets/img/返回.png" alt=""> 返回首页</span>
      </el-row>
      <el-row class="detailInfo">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">账号名</el-col>
        <el-col v-if="userInfo" :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="titleContent">{{userInfo.userName}}</el-col>
      </el-row>
      <el-divider></el-divider>
      <!-- <el-row class="detailInfo">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">人员编号</el-col>
        <el-col v-if="userInfo" :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="titleContent">{{userInfo.personNo}}</el-col>
      </el-row> -->
      <!-- <el-divider></el-divider> -->
      <el-row class="detailInfo">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">
          账号密码
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" v-if="userInfo" class="titleContent">
          当前密码强度：<span class="strong">强</span>
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
          <img src="@/assets/img/编辑.png" alt="" @click="editAdminPwVisible=true">
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row class="detailInfo" v-if="email!='wwj13012021@163.com'&&email!='wwj1301@126.com'">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">
          登录邮箱、消息接收邮箱
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" v-if="userInfo" class="titleContent">
          已绑定邮箱:{{ userInfo.email.substr(0, 3) + '****' + userInfo.email.substr(7)}},可用于重置密码和接收重要通知
        </el-col>
        <el-col v-if="userInfo" :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
          <img src="@/assets/img/编辑.png" alt="" @click="editInfoVisible=true">
        </el-col>
      </el-row>
      <el-divider v-if="email!='wwj13012021@163.com'&&email!='wwj1301@126.com'"></el-divider>
      
      <!-- <el-row class="detailInfo">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="titleName">
          手机绑定
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" v-if="userInfo" class="titleContent">
          已绑定手机号:{{userInfo.phone}},可用于接收重要通知
        </el-col>
        <el-col v-if="userInfo" :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
          <img src="@/assets/img/编辑.png" alt="" @click="editInfoVisible=true">
        </el-col>
      </el-row> -->
      <!-- <el-divider></el-divider> -->
    </el-row>

    <!-- 修改admin密码弹框 -->
    <el-dialog title="修改登录密码" :visible.sync="editAdminPwVisible" width="25%" custom-class="editPasswrd" @close="closeAdminPwDialog">
      <el-form :model="editAdminPwRuleForm" status-icon :rules="editAdminPwRules" ref="editAdminPwRuleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" placeholder="请输入旧密码" show-password v-model="editAdminPwRuleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" placeholder="请输入新密码" show-password v-model="editAdminPwRuleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码" prop="checkPass">
          <el-input type="password" placeholder="请再次确认密码" show-password v-model="editAdminPwRuleForm.checkPass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="userInfo">
        <el-button type="primary" @click="holdNewAdminPw(5,userInfo.id)" class="button add">保存</el-button>
        <el-button @click="editAdminPwVisible=false" class="button cancel">取 消</el-button>
      </span>

    </el-dialog>

    <!-- 新建/修改平台管理员 -->
    <el-dialog :title="flag==1?'新建平台管理员':'编辑人员信息'" :visible.sync="addAdminVisible" width="35%" custom-class="addInfoVisible addAdminVisible" @close="closeDialog">
      <el-form :model="addAdminForm" :rules="addAdminFormRules" ref="addAdminForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="人员编号" prop="personNo">
          <el-input v-model="addAdminForm.personNo"></el-input>
        </el-form-item>
        <el-form-item label="权 限">
          <el-tag :key="index" v-for="(tag,index) in tagsData" closable :disable-transitions="false" @close="handleClose(tag,index)">
            {{tag.name}}
          </el-tag>
          <div class="userPermission" @click="handlePermission"><i class="el-icon-plus"></i> 添加</div>
        </el-form-item>
        <el-form-item label="账号名" prop="userName">
          <el-input v-model="addAdminForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="邮 箱" prop="email">
          <el-input v-model="addAdminForm.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addAdminForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="密 码" prop="password" v-if="flag==1">
          <el-input type="password" show-password auto-complete="new-password" v-model="addAdminForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span v-if="flag==1" class="button add" type="primary" @click="submitAdmin">新 增</span>
        <span v-else-if="flag==2" class="button add" type="primary" @click="submitEditAdmin">修 改</span>
        <span class="button" @click="addAdminVisible = false">取 消</span>
      </span>
    </el-dialog>
    <!-- 添加/修改平台管理员权限 -->
    <el-dialog :title="flag==1?'添加平台管理员权限':'修改平台管理员权限'" :visible.sync="addPermissionVisible" width="30%" custom-class="addPermission">
      <!-- <el-row class="especially">特殊权限</el-row> -->
      <div v-for="(item,index) in permissionData" :key="index" class="permissionData">
        <!-- 可灵活添加一次性权限,暂不删除,若后期添加可直接操作 -->
        <el-button class="power" :class="{activeStyle:item.status}" type="primary" @click="clickButton(item,index)">{{item.name}}</el-button>
        <!-- <el-button class="activeStyle" type="primary">{{item.name}}</el-button> -->
        <!-- <el-row class="specialTips">
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <i class="el-icon-warning iconStyle"></i>
          </el-col>
          <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
            <span>该功能请谨慎开放权限,并且该权限是一次性的，协会工作人员只在下次登录的那一次才能使用</span>
          </el-col>
        </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="permissionSure">确 定</span>
        <span class="button" type="primary" @click="cancelButton">取消</span>
      </span>
    </el-dialog>
    <!-- 修改密码弹框 -->
    <el-dialog title="重置协会人员登录密码" :visible.sync="passwordVisible" width="25%" custom-class="editPasswrd" @close="closeEditDialog">
      <el-form :model="editPasswordRuleForm" status-icon :rules="editPasswordRules" ref="editPasswordRuleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" placeholder="请输入新密码" show-password v-model="editPasswordRuleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码" prop="checkPass">
          <el-input type="password" placeholder="请再次确认密码" show-password v-model="editPasswordRuleForm.checkPass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="holdNewPassword" class="button add">保存</el-button>
        <el-button @click="passwordVisible=false" class="button">取 消</el-button>
      </span>

    </el-dialog>
    <!-- 更改绑定邮箱 -->
    <el-dialog title="更改绑定邮箱" :visible.sync="editInfoVisible" width="35%" custom-class="editInfoVisible" @close="closeeditInfoDialog">
      <el-steps :active="stepActive" v-if="stepActive==0 ||stepActive==1">
        <el-step title="验证账号"></el-step>
        <el-step title="变更信息"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <el-divider v-if="stepActive==0 ||stepActive==1"></el-divider>
      <el-form :model="editInfoForm" status-icon :rules="editInfoRules" ref="editInfoForm" label-width="90px" class="editInfoForm editPassward" v-show="stepActive==0">
        <el-form-item label="当前邮箱" prop="email" v-if="userInfo">
          {{userInfo.email}}
          <el-button :disabled="isDisable" type="primary" @click="sendCode(userInfo.email)" class="button send">{{isDisable?`${time}s`:'获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="code" class="code firstCode">
          <el-input type="password" placeholder="请输入验证码" v-model="editInfoForm.captcha"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="newEmailForm" status-icon :rules="newEmailRules" ref="newEmailForm" label-width="90px" class="editInfoForm newEmailForm" v-show="stepActive==1">
        <el-form-item label="新邮箱" prop="newEmail">
          <el-input auto-complete="new-password" class="newEmail" placeholder="请输入新邮箱" v-model="newEmailForm.newEmail"></el-input>
          <el-button type="primary" :disabled="isDisable" @click="sendCode(newEmailForm.newEmail)" class="button send">{{isDisable?`${time}s`:'获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" class="code">
          <el-input auto-complete="new-password" type="password" placeholder="请输入验证码" v-model="newEmailForm.captcha"></el-input>
        </el-form-item>
      </el-form>
      <el-row v-if="stepActive==2" style="text-align:center;">
        <img src="@/assets/img/修改成功.png" alt="">
        <p>修改成功!</p>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="stepActive==0" type="primary" @click="next" class="button">下一步</el-button>
        <el-button v-if="stepActive==1" type="primary" @click="previousStep" class="button">上一步</el-button>
        <el-button v-if="stepActive==1" type="primary" @click="nextStep" class="button nextSure">确定</el-button>
        <el-button v-if="stepActive==2" type="primary" @click="editSuccess" class="button nextSure">确定</el-button>
      </span>

    </el-dialog>

  </div>
</template>
<script>
import adminJs from '@/assets/js/Admin/admin'
export default {
  ...adminJs
}
</script>
<style lang='less' scoped>
#admin {
  height: 100%;
  padding: 20px 15px 0 50px;
  background-color: #f3f6f9;
  i {
    cursor: pointer;
  }
  .admin_header {
    .admin_header_l {
      font-size: 16px;
      img {
        vertical-align: middle;
      }
      h3 {
        color: #286ac4;
      }
      p {
        margin-top: 15px;
        color: #6a707e;
      }
    }
    .admin_header_r {
      text-align: right;
      font-size: 15px;
      display: flex;
      align-items: center;
      .loginTime {
        color: #ccc;
        img {
          vertical-align: middle;
          margin-right: 10px;
          width: 16px;
        }
        span {
          display: inline-block;
          margin-left: 10px;
        }
      }
      .userInfos {
        text-align: center;
        .el-avatar {
          vertical-align: middle !important;
        }
      }
      .logout {
        text-align: left;
        color: #0066cc;
        .el-icon-switch-button:before {
          font-weight: 600;
        }
      }
    }
  }
  .admin_content {
    margin-top: 35px;
    .addNew {
      width: 120px;
    }
    .more {
      cursor: pointer;
    }
    .backHome {
      color: #1296db;
      font-size: 17px;
      width: 100px !important;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 5px;
        vertical-align: bottom;
      }
    }
    .detailInfo {
      font-size: 16px;
      margin-top: 35px;
      .titleName {
        font-weight: 550;
      }
      .titleContent {
        color: #666;
      }
      img {
        cursor: pointer;
      }
    }
    .selectOprate {
      margin: 10px 0 20px;
      span {
        width: 150px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
        border: solid 1px #d9d9d9;
        cursor: pointer;
        color: #999999;
        display: inline-block;
        background-color: #f3f6f9;
      }
      .mine {
        border-radius: 3px 0 0 3px;
        border-right: none;
      }
      .other {
        border-radius: 0 3px 3px 0;
        border-left: none;
        margin-right: 31%;
      }
      .active {
        color: #fff;
        background: linear-gradient(-45deg, #286ac4 0%, #3793f4 100%);
      }
    }
  }
  /deep/.addAdminVisible {
    .userPermission {
      display: inline-block;
      color: #0566cc;
    }
    .el-input__suffix {
      right: 11%;
    }
  }
  /deep/ .addPermission {
    .el-dialog__body {
      text-align: center;
    }
    .permissionData {
      display: inline-block;
      margin-left: 20px;

      .el-button--primary {
        width: 145px;
        background: #fff;
        border: 1px solid #0e6fd0;
        border-radius: 17px;
        color: #0e6fd0;
      }
      .activeStyle {
        background: #0e6fd0;
        color: #fff;
      }
    }
    .especially {
      font-weight: 550;
      font-size: 15px;
      margin-bottom: 15px;
    }
    .specialTips {
      display: inline-block;
      margin-left: 30px;
      width: 70%;
      height: 85px;
      line-height: 20px;
      border: 1px solid #0e6fd0;
      border-radius: 5px;
      background: #d4e4f8;
      padding: 10px 15px;
      .iconStyle {
        display: inline-block;
        color: #0e6fd0;
        font-size: 20px;
      }
    }
  }
  .el-tag {
    margin-right: 5px;
  }
  .editPasswrd {
    .el-dialog__footer {
      .el-button {
        line-height: 0;
      }
    }
  }
  /deep/ .editInfoVisible {
    .el-dialog__body {
      padding: 30px 40px !important;
      .editInfoForm {
        color: #666;
        margin-top: 30px;
        .send {
          width: 130px;
          background-image: linear-gradient(260deg, #096bd0 0%, #209afd 100%);
          margin-left: 5px;
        }
      }
      .newEmailForm {
        .el-input {
          width: 56%;
        }
      }
      .code {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      .firstCode {
        .el-input {
          width: 55% !important;
        }
        .el-input__inner {
          width: 100%;
        }
      }
    }
    .el-button {
      background-color: #286ac4;
      color: #fff;
      line-height: 0;
      width: 90px;
    }
    .nextSure {
      background-color: #fff;
      color: #0066cc;
    }
  }
}
</style>
